import {
  IconAlertCircle,
  IconAlertTriangle,
  IconBell,
  IconBriefcase,
  IconChartBar,
  IconCloud,
  IconDatabase,
  IconServer,
  IconTrendingUp,
  IconTrendingDown,
  IconExclamationMark,
  IconInfoCircle,
  IconCheck,
  IconX,
  IconQuestionMark,
  IconProps,
  IconBrandSlack,
} from "@tabler/icons-react"

// Icon mapping for dynamic icon rendering
const iconMap: Record<string, React.ComponentType<IconProps>> = {
  IconAlertCircle,
  IconAlertTriangle,
  IconBell,
  IconBriefcase,
  IconChartBar,
  IconCloud,
  IconDatabase,
  IconServer,
  IconTrendingUp,
  IconTrendingDown,
  IconExclamationMark,
  IconInfoCircle,
  IconCheck,
  IconX,
  IconQuestionMark,
  IconBrandSlack,
}

interface DynamicIconProps {
  iconName?: string
  size?: number
  className?: string
}

/**
 * DynamicIcon component that renders Tabler icons based on icon names
 * @param iconName - The name of the icon to render (e.g., "IconAlertCircle")
 * @param size - The size of the icon (default: 24)
 * @param className - Additional CSS classes
 * @returns The rendered icon component or a fallback IconAlertCircle
 */
export const DynamicIcon = ({
  iconName,
  size = 24,
  className,
}: DynamicIconProps) => {
  if (!iconName) {
    return <IconAlertCircle size={size} className={className} />
  }

  const IconComponent = iconMap[iconName]
  if (IconComponent) {
    return <IconComponent size={size} className={className} />
  }

  // Fallback to default icon if icon name is not found
  return <IconAlertCircle size={size} className={className} />
}

export default DynamicIcon
